import { render, staticRenderFns } from "./QuickLabel.vue?vue&type=template&id=55b23bf8&scoped=true&"
import script from "./QuickLabel.vue?vue&type=script&lang=js&"
export * from "./QuickLabel.vue?vue&type=script&lang=js&"
import style0 from "./QuickLabel.vue?vue&type=style&index=0&id=55b23bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b23bf8",
  null
  
)

export default component.exports